module.exports = __webpack_public_path__ + "static/media/Layout16.4d256f9a.png";